import { StepFamily } from './DsType';

export enum Step {
  LOGEMENT = 'logement',
  CREDITS = 'credits',
  NOUVEAUPROJECT = 'nouveauproject',
  IDENTITE = 'identite',
  CONTACT = 'contact',
  NATIONALITE = 'nationalite',
  NAISSANCE = 'naissance',
  ADRESSE = 'adresse',
  RECAPITULATIF = 'recapitulatif',
  SITUATIONFAMILIALE = 'situation-familiale',
  SITUATIONPRO = 'situation-professionnelle',
  REVENUS = 'revenus',
  REVENUSSUITE = 'revenus-suite',
  DEPENSES = 'depenses-mensuelles',
  BANQUE = 'banque',
  CONFIRM = 'confirmer',
  INSURANCE = 'assurance',
  RESPONSE = 'reponse',
  // RECAP = 'recap',
}

export interface StepModel {
  name: Step;
  navLabel: string;
  family: StepFamily;
  title: string;
  description?: string;
  path: string;
  order: number;
  webAnalyseDetails?: WebAnalysePageModel;
}

export interface WebAnalysePageModel {
  stepNumber: string;
  stepLabel: string;
  pageName: string;
}

export const stepByName = (name: Step): StepModel | undefined => {
  return steps.find((step) => step.name === name);
};
export const stepByNameLocataire = (name: Step): StepModel | undefined => {
  return stepsLocataire.find((step) => step.name === name);
};
export const isFamilyWithStep = (family: StepFamily): boolean => {
  return family === StepFamily.ABOUT;
};

export const retrieveFamilyKey = (family: StepFamily): keyof typeof StepFamily | undefined => {
  return (Object.keys(StepFamily) as (keyof typeof StepFamily)[]).find((familyKey) => StepFamily[familyKey] === family);
};

export const retrieveStepKey = (name: Step): keyof typeof Step | undefined => {
  return (Object.keys(Step) as (keyof typeof Step)[]).find((stepKey) => Step[stepKey] === name);
};

export const steps: StepModel[] = [
  {
    name: Step.LOGEMENT,
    navLabel: 'Situation de logement',
    family: StepFamily.ABOUT,
    title: 'Dites nous-en plus sur votre logement',
    path: 'logement',
    order: 1,
    webAnalyseDetails: {
      stepNumber: '1',
      stepLabel: 'Logement',
      pageName: 'RAC : Form : step 1',
    },
  },
  {
    name: Step.CREDITS,
    navLabel: 'Crédits en cours',
    family: StepFamily.ABOUT,
    title: 'Vos crédits en cours',
    path: 'credits',
    order: 2,
    webAnalyseDetails: {
      stepNumber: '2',
      stepLabel: 'Credit en cours',
      pageName: 'RAC : Form : step 2',
    },
  },
  {
    name: Step.NOUVEAUPROJECT,
    navLabel: 'Nouveau projet',
    family: StepFamily.ABOUT,
    title: 'Votre nouveau projet',
    path: 'nouveau-projet',
    order: 3,
    webAnalyseDetails: {
      stepNumber: '3',
      stepLabel: 'Nouveau projet',
      pageName: 'RAC : Form : step 3',
    },
  },
  {
    name: Step.IDENTITE,
    navLabel: 'Identité',
    family: StepFamily.ABOUT,
    title: 'Faisons connaissance',
    description:
      "Assurez-vous que ces informations sont identiques à celles présentes sur votre pièce d'identité (carte d'identité, passeport…).",
    path: 'identite',
    order: 4,
    webAnalyseDetails: {
      stepNumber: '4',
      stepLabel: 'Identite',
      pageName: 'RAC : Form : step 4',
    },
  },
  {
    name: Step.NATIONALITE,
    navLabel: 'Nationalité',
    family: StepFamily.ABOUT,
    title: 'Quelle est votre nationalité ?',
    description: 'Ces informations vont nous permettre de pré-remplir votre contrat.',
    path: 'nationalite',
    order: 5,
    webAnalyseDetails: {
      stepNumber: '5',
      stepLabel: 'Nationalite',
      pageName: 'RAC : Form : step 5',
    },
  },
  {
    name: Step.NAISSANCE,
    navLabel: 'Informations de naissance',
    family: StepFamily.ABOUT,
    title: 'Quand et où êtes-vous né ?',
    description: "Nous avons besoin d'en savoir plus sur votre identité.",
    path: 'naissance',
    order: 6,
    webAnalyseDetails: {
      stepNumber: '6',
      stepLabel: 'Date naissance',
      pageName: 'RAC : Form : step 6',
    },
  },
  {
    name: Step.SITUATIONFAMILIALE,
    navLabel: 'Situation familiale',
    family: StepFamily.ABOUT,
    title: 'Quelle est la composition de votre foyer ?',
    path: 'situation-familiale',
    order: 7,
    webAnalyseDetails: {
      stepNumber: '7',
      stepLabel: 'Situation familiale',
      pageName: 'RAC : Form : step 7',
    },
  },
  {
    name: Step.SITUATIONPRO,
    navLabel: 'Situation professionnelle',
    family: StepFamily.ABOUT,
    title: 'Que faites-vous dans la vie ?',
    path: 'situation-professionnelle',
    order: 8,
    webAnalyseDetails: {
      stepNumber: '8',
      stepLabel: 'Situation professionnelle',
      pageName: 'RAC : Form : step 8',
    },
  },
  {
    name: Step.REVENUS,
    navLabel: 'Revenus mensuels',
    family: StepFamily.ABOUT,
    title: 'Quelles sont vos ressources mensuelles ?',
    description: `Les informations sur vos revenus et charges vont nous permettre d'évaluer votre situation financière.`,
    path: 'revenus',
    order: 9,
    webAnalyseDetails: {
      stepNumber: '9',
      stepLabel: 'Ressources',
      pageName: 'RAC : Form : step 9',
    },
  },
  {
    name: Step.CONTACT,
    navLabel: 'Contact',
    family: StepFamily.ABOUT,
    title: 'Comment peut-on vous contacter ?',
    description:
      'Nous avons besoin de vos coordonnées pour vous tenir informé(e) de l’évolution de votre demande. Vérifiez que vos informations sont exactes.',
    path: 'contact',
    order: 10,
    webAnalyseDetails: {
      stepNumber: '11',
      stepLabel: 'Contact',
      pageName: 'RAC : Form : step 11',
    },
  },
  {
    name: Step.ADRESSE,
    navLabel: 'Adresse postale',
    family: StepFamily.ABOUT,
    title: 'Votre adresse postale',
    description:
      'En nous indiquant votre adresse, nous gardons le contact pour vous envoyer des documents importants suite à votre demande.\n Vérifiez que l’ensemble des champs ci-dessous ne comporte pas d’erreur.',
    path: 'adresse',
    order: 11,
    webAnalyseDetails: {
      stepNumber: '12',
      stepLabel: 'Adresse',
      pageName: 'RAC : Form : step 12',
    },
  },
  {
    name: Step.RECAPITULATIF,
    navLabel: 'Dernière étape',
    family: StepFamily.ABOUT,
    title: 'Dernière étape',
    description: '',
    path: 'derniere-etape',
    order: 12,
    webAnalyseDetails: {
      stepNumber: '13',
      stepLabel: 'Derniere etape',
      pageName: 'RAC : Form : step 13',
    },
  },
  {
    name: Step.RESPONSE,
    navLabel: 'reponse',
    family: StepFamily.RESPONSE,
    title: 'Réponse de principe ',
    path: 'response',
    order: 13,
    webAnalyseDetails: {
      // en attendant la page recap, le stepNumber pour la webA doit être 13
      stepNumber: '14',
      stepLabel: 'Réponse',
      pageName: 'RAC : Form : step 14',
    },
  },
];

export const stepsLocataire: StepModel[] = [
  {
    name: Step.LOGEMENT,
    navLabel: 'Situation de logement',
    family: StepFamily.ABOUT,
    title: 'Dites nous-en plus sur votre logement',
    path: 'logement',
    order: 1,
    webAnalyseDetails: {
      stepNumber: '1',
      stepLabel: 'Logement',
      pageName: 'RAC : Form : step 1',
    },
  },
  {
    name: Step.CREDITS,
    navLabel: 'Crédits en cours',
    family: StepFamily.ABOUT,
    title: 'Vos crédits en cours',
    path: 'credits',
    order: 2,
    webAnalyseDetails: {
      stepNumber: '2',
      stepLabel: 'Credit en cours',
      pageName: 'RAC : Form : step 2',
    },
  },
  {
    name: Step.NOUVEAUPROJECT,
    navLabel: 'Nouveau projet',
    family: StepFamily.ABOUT,
    title: 'Votre nouveau projet',
    path: 'nouveau-projet',
    order: 3,
    webAnalyseDetails: {
      stepNumber: '3',
      stepLabel: 'Nouveau projet',
      pageName: 'RAC : Form : step 3',
    },
  },
  {
    name: Step.IDENTITE,
    navLabel: 'Identité',
    family: StepFamily.ABOUT,
    title: 'Faisons connaissance',
    description:
      "Assurez-vous que ces informations sont identiques à celles présentes sur votre pièce d'identité (carte d'identité, passeport…).",
    path: 'identite',
    order: 4,
    webAnalyseDetails: {
      stepNumber: '4',
      stepLabel: 'Identite',
      pageName: 'RAC : Form : step 4',
    },
  },
  {
    name: Step.NATIONALITE,
    navLabel: 'Nationalité',
    family: StepFamily.ABOUT,
    title: 'Quelle est votre nationalité ?',
    description: 'Ces informations vont nous permettre de pré-remplir votre contrat.',
    path: 'nationalite',
    order: 5,
    webAnalyseDetails: {
      stepNumber: '5',
      stepLabel: 'Nationalite',
      pageName: 'RAC : Form : step 5',
    },
  },
  {
    name: Step.NAISSANCE,
    navLabel: 'Informations de naissance',
    family: StepFamily.ABOUT,
    title: 'Quand et où êtes-vous né ?',
    description: "Nous avons besoin d'en savoir plus sur votre identité.",
    path: 'naissance',
    order: 6,
    webAnalyseDetails: {
      stepNumber: '6',
      stepLabel: 'Date naissance',
      pageName: 'RAC : Form : step 6',
    },
  },
  {
    name: Step.SITUATIONFAMILIALE,
    navLabel: 'Situation familiale',
    family: StepFamily.ABOUT,
    title: 'Quelle est la composition de votre foyer ?',
    path: 'situation-familiale',
    order: 7,
    webAnalyseDetails: {
      stepNumber: '7',
      stepLabel: 'Situation familiale',
      pageName: 'RAC : Form : step 7',
    },
  },
  {
    name: Step.SITUATIONPRO,
    navLabel: 'Situation professionnelle',
    family: StepFamily.ABOUT,
    title: 'Que faites-vous dans la vie ?',
    path: 'situation-professionnelle',
    order: 8,
    webAnalyseDetails: {
      stepNumber: '8',
      stepLabel: 'Situation professionnelle',
      pageName: 'RAC : Form : step 8',
    },
  },
  {
    name: Step.REVENUS,
    navLabel: 'Revenus mensuels',
    family: StepFamily.ABOUT,
    title: 'Quelles sont vos ressources mensuelles ?',
    description: `Les informations sur vos revenus et charges vont nous permettre d'évaluer votre situation financière.`,
    path: 'revenus',
    order: 9,
    webAnalyseDetails: {
      stepNumber: '9',
      stepLabel: 'Ressources',
      pageName: 'RAC : Form : step 9',
    },
  },
  {
    name: Step.DEPENSES,
    navLabel: 'Dépenses mensuelles',
    family: StepFamily.ABOUT,
    title: 'Quelles sont vos dépenses mensuelles ?',
    description: 'Veuillez déclarer les charges que vous payez chaque mois dans leur globalité.',
    path: 'depenses',
    order: 10,
    webAnalyseDetails: {
      stepNumber: '10',
      stepLabel: 'Depenses',
      pageName: 'RAC : Form : step 10',
    },
  },
  {
    name: Step.CONTACT,
    navLabel: 'Contact',
    family: StepFamily.ABOUT,
    title: 'Comment peut-on vous contacter ?',
    description:
      'Nous avons besoin de vos coordonnées pour vous tenir informé(e) de l’évolution de votre demande. Vérifiez que vos informations sont exactes.',
    path: 'contact',
    order: 11,
    webAnalyseDetails: {
      stepNumber: '11',
      stepLabel: 'Contact',
      pageName: 'RAC : Form : step 11',
    },
  },
  {
    name: Step.ADRESSE,
    navLabel: 'Adresse postale',
    family: StepFamily.ABOUT,
    title: 'Votre adresse postale',
    description:
      'En nous indiquant votre adresse, nous gardons le contact pour vous envoyer des documents importants suite à votre demande.\n Vérifiez que l’ensemble des champs ci-dessous ne comporte pas d’erreur.',
    path: 'adresse',
    order: 12,
    webAnalyseDetails: {
      stepNumber: '12',
      stepLabel: 'Adresse',
      pageName: 'RAC : Form : step 12',
    },
  },
  {
    name: Step.RECAPITULATIF,
    navLabel: 'Dernière étape',
    family: StepFamily.ABOUT,
    title: 'Dernière étape',
    description: '',
    path: 'derniere-etape',
    order: 13,
    webAnalyseDetails: {
      stepNumber: '13',
      stepLabel: 'Derniere etape',
      pageName: 'RAC : Form : step 13',
    },
  },
  {
    name: Step.RESPONSE,
    navLabel: 'reponse',
    family: StepFamily.RESPONSE,
    title: 'Réponse de principe ',
    path: 'response',
    order: 14,
    webAnalyseDetails: {
      // en attendant la page recap, le stepNumber pour la webA doit être 14
      stepNumber: '14',
      stepLabel: 'Réponse',
      pageName: 'RAC : Form : step 14',
    },
  },
];
